import { Link } from "react-router-dom";
import styles from "./heading.module.css";

const Heading = ({ title, more = null, icon = null }) => {
  return (
    <div className={styles.headingWrapper}>
      <h2>
        <span>
          {icon && (
            <span className={styles.iconHeader}>
              {icon && <i className={icon} />}
            </span>
          )}
          {title}
        </span>
        {more && (
          <Link to={more}>
            {`همه ${title}`} <i className="fa fa-arrow-left" />
          </Link>
        )}
      </h2>
    </div>
  );
};

export default Heading;
